module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国中央革命军事委员会旧址.e4667b56.png";